import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type { BeniSmartCompset, BeniSmartCompsetCategory } from 'lumen/models';
import type HotelSettingsCompetitorsBenchmarkRoute from 'lumen/routes/hotel/settings/competitors/benchmark';
import { BENI_SMART_COMPSET_CATEGORY_TRANSLATIONS } from 'lumen/utils/constants/benchmark-insight/beni-smart-compset-constant-values';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkSmartCompsetCategoriesController extends Controller {
  declare model: ModelFrom<HotelSettingsCompetitorsBenchmarkRoute>;

  @service declare intl: Services['intl'];
  @service declare router: Services['router'];

  get aiSuggestions(): string[] {
    const beSuggestions = this.categories.filter((cat) => cat.suggestion);
    const aiSuggestions = beSuggestions.map((beSuggestion) =>
      this.intl.t(BENI_SMART_COMPSET_CATEGORY_TRANSLATIONS[beSuggestion.name]),
    );

    return aiSuggestions;
  }

  get categories(): BeniSmartCompsetCategory[] {
    return this.smartCompset?.categories ?? [];
  }

  get isContinueDisabled(): boolean {
    return (
      this.categories.filter((category) => category.isChecked).length === 0
    );
  }

  get smartCompset(): BeniSmartCompset | null | undefined {
    return this.model.smartCompset.last?.value;
  }

  @action
  onCloseModal(): void {
    this.router.transitionTo('hotel.settings.competitors.benchmark');
  }

  @action
  onContinue(): void {
    this.router.transitionTo(
      'hotel.settings.competitors.benchmark.smart-compset.weights',
    );
  }

  @action
  toggleCategory(category: BeniSmartCompsetCategory): void {
    this.smartCompset?.toggleCategory(category);
  }
}
